/**
 * Indicate if the given date is in the future.
 */
export const isFutureDate = (date: Date | string): boolean => {
  return new Date(date).getTime() - new Date().getTime() > 0
}
